import { Viewer, Worker } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import charte from 'assets/files/charte-cooperation.pdf';
import { Button } from 'components/Button/Button';
import { Switch } from 'components/Switch/Switch';
import React from 'react';
import './PrivacyPolicy.scss';
import { usePrivacyPolicyVM } from './usePrivacyPolicyVM';

export const PrivacyPolicy: React.FC = () => {
    const { isPrivacyPolicyAccepted, setIsPrivacyPolicyAccepted, handleAcceptPrivacyPolicy } = usePrivacyPolicyVM();

    return (
        <div id="privacy-policy">
            <div className="privacy-policy-wrapper">
                <h1 style={{ marginTop: '20px', marginBottom: '0px' }}>Charte de coopération</h1>
                <p style={{ textAlign: 'center' }}>
                    Bienvenue ! Avant de commencer, nous vous invitons à lire attentivement la charte de coopération.<br></br>
                    Pour poursuivre, vous devez en prendre connaissance et l’approuver afin de garantir une coopération basée sur la
                    confiance et la compréhension mutuelle.
                </p>

                <div className="charte-confidentialite-wrapper">
                    <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}>
                        <Viewer fileUrl={charte} defaultScale={1} />
                    </Worker>
                </div>

                <Switch
                    label="J'ai lu et accepte la charte de coopération"
                    checked={isPrivacyPolicyAccepted}
                    onChange={(checked) => setIsPrivacyPolicyAccepted(checked)}
                />
                <Button
                    style={{ marginTop: '10px' }}
                    label="Accepter"
                    variant="dark"
                    disabled={!isPrivacyPolicyAccepted}
                    callback={handleAcceptPrivacyPolicy}
                />
            </div>
        </div>
    );
};
